import React from "react";
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from "prop-types";
import MaterialTable from 'material-table'
import * as i18n from "../common/i18n";
import Message from "../components/Message";
import * as helper from "../common/helper";

const styles = theme => ({
});


class DetailTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            message: null,
            confirm: false,
            working: false,
            resetObject: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        };

        this.tableRef = React.createRef();
    }

    render() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                maxHeight={'md'}
                open={this.props.open}
                keepMounted
                onClose={this.props.onCancel}
            >

                <DialogTitle>{this.props.dialogTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                    </DialogContentText>

                    <div>
                    {this.props.tableLoading && <div style={{ width: "100%" }}><LinearProgress /></div>}
                        {this.props.open &&
                            <MaterialTable width={'99%'}
                                components={{
                                    Cell: helper.defaultCell,
                                    FilterRow: helper.defaultFilter
                                }}
                                tableRef={this.tableRef}
                                localization={i18n.getLocalization()}
                                columns={this.props.columns}
                                data={this.props.data}
                                options={{
                                    exportButton: false,
                                    filtering: false,
                                    showTitle: false,
                                    debounceInterval: 500,
                                    search: false,
                                    columnsButton: false,
                                    pageSize: 10,
                                    paging: false
                                }}
                            />
                        }
                        <Message
                            hideAfter={this.state.hideAfter}
                            onClose={this.closeMessage}
                            variant={this.state.variant}
                            message={this.state.message}
                            details={this.state.details}
                            open={this.state.message !== null}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onCancel} color="primary">
                        {this.props.cancelText}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

DetailTable.propTypes = {
    classes: PropTypes.object.isRequired,
};



export default withStyles(styles, { withTheme: true })(DetailTable)